import {
    Grid,
} from '@chakra-ui/react';

const CARD_BORDER_PADDING = 5;
const gap = 2;
const rowGap = 2;

function ServiceGrid({ children }: { children: React.ReactNode }) {
    return (
        <Grid
            gridTemplateRows="auto"
            gridTemplateAreas='"services last-service-date next-service-date service-provider further-works action"'
            gridTemplateColumns="1fr 8fr 8fr 8fr 4fr 0.5fr"
            gap={{ base: gap, xl: gap }}
            alignItems={{ base: 'center', xl: 'start' }}
            justifyItems="start"
            h="auto"
            w="full"
        >
            {children}
        </Grid>
    );
}

function CardHeaderGrid({ children }: { children: React.ReactNode }) {
    return (
        <Grid
            gridTemplateRows="auto"
            gridTemplateAreas={`
                "property-address  save-button"
            `}
            gridTemplateColumns="1fr 1fr"
            gap={{ base: gap, xl: 0 }}
            rowGap={{ base: rowGap, xl: rowGap }}
            alignItems={{ base: 'center', xl: 'start' }}
            justifyItems="start"
            h="auto"
            w="full"
        >
            {children}
        </Grid>
    );
}

export {
    CARD_BORDER_PADDING,
    CardHeaderGrid,
    ServiceGrid,
};
